import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../../../reduxService/hooks';
import { selectProjectInfo, selectMacro2 } from '../../../../store/projectInfo/projectInfoSlice';
import './SiteEnvLevel.scss';
import MenuItem from '@mui/material/MenuItem';
import Grid from '@mui/material/Grid';
import { ErrorMessage, Field, FormikProvider, useFormik } from 'formik';
import * as Yup from 'yup';
import Select, { SelectProps } from '@mui/material/Select';
import { setSiteEnvLevel } from '../../../store/project/projectslice';
import { RootState } from '../../../../../reduxService';
import { useEffect } from 'react';
import { updateValidation } from '../../../store/project/resultsSlice';
import { getProjectSiteEnvLevelAsync } from '../../../../api/store/BeMaccaferriStoreHelper';
import FieldNumber from '../../../../../components/FieldNumber/FieldNumber';
import { ISiteEnvLevel } from '../../../../pages/ProjectInfo/IProjectInfo';
import { ISiteEnvLevelProps } from './ISiteEnvLevel';

export const SiteEnvironmentalLevelDefault: string = '';

const MuiSelect = (props: SelectProps) => <Select {...props} />;

const SiteEnvLevel = (props: ISiteEnvLevelProps) => {
    const { t } = useTranslation();
    const [siteEnvLevelsList, setsiteEnvLevelsList] = React.useState<ISiteEnvLevel[]>([]);
    const [selectedSiteEnvLevel, setSelectedSiteEnvLevel] = React.useState<ISiteEnvLevel | undefined>(undefined);

    const projectInfo = useAppSelector(selectProjectInfo);
    const macro2 = useAppSelector(selectMacro2);

    const SiteEnvLevelValidationSchema = Yup.object().shape({
        siteEnvironmentalLevelId: Yup.string().required().label(t('site_env_level', { unit_measure: '' }))
    });

    const dispatch = useAppDispatch();
    const dispatchSiteEnvLevel = (payload: string) => {
        dispatch(setSiteEnvLevel(payload));
    }

    const formikProps = useFormik({
        initialValues: {
            siteEnvironmentalLevelId: macro2.project?.data?.siteEnvironmentalLevelId ?? SiteEnvironmentalLevelDefault,
        },
        validationSchema: SiteEnvLevelValidationSchema,
        onSubmit: (values, { setSubmitting }) => {
            setSubmitting(false);
        },
    });

    useEffect(() => {
        getProjectSiteEnvLevelAsync(window.localStorage.getItem("i18nextLng") ?? 'en-US').then((response) => {
            setsiteEnvLevelsList(response.data);
            const selectedSiteEnvLevel = response.data.find((el) => el.id === formikProps.values.siteEnvironmentalLevelId)
                ?? response.data[0];
            if (formikProps.values.siteEnvironmentalLevelId === '' && selectedSiteEnvLevel) {
                formikProps.setFieldValue('siteEnvironmentalLevelId', selectedSiteEnvLevel.id);
                formikProps.setFieldValue('siteEnvironmentalLevelName', selectedSiteEnvLevel.name);
            }
            setSelectedSiteEnvLevel(selectedSiteEnvLevel);
        });
    }, [window.localStorage.getItem("i18nextLng")]);

    const handleValueChanged = (valueKey: string, value: any) => {
        formikProps.setFieldValue(valueKey, value);
        if (valueKey === 'siteEnvironmentalLevelId') {
            const selectedLevel = siteEnvLevelsList.find((el) => el.id === value);

            setSelectedSiteEnvLevel(selectedLevel);

            if (selectedLevel) {
                formikProps.setFieldValue('siteEnvironmentalLevelName', selectedSiteEnvLevel?.name);
            }
        }
    };

    useEffect(() => {
        dispatch(setSiteEnvLevel(formikProps.values.siteEnvironmentalLevelId));
    }, [formikProps.values]);

    const currentResults = useAppSelector((state: RootState) => {
        return { ...state.Macro2.results.data };
    });

     useEffect(() => {
         if (currentResults.validation?.startValidation && !currentResults.validation?.siteEnvironmentalLevel) {
             formikProps.submitForm();
             formikProps.validateForm().then((errors) => {
                 if (currentResults.validation) {
                    dispatch(updateValidation({
                        ...currentResults.validation,
                        siteEnvironmentalLevel: true,
                        siteEnvironmentalLevelErrors: Object.keys(errors).length > 0,
                    }));
                 }
             });
         }
     }, [JSON.stringify(currentResults.validation)]);

    return (
        <div className='style-form'>
            <FormikProvider value={formikProps}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <label>{t('site_environmental_level')}</label>
                        <Field
                            as={MuiSelect}
                            name="siteEnvironmentalLevelId"
                            value={formikProps.values.siteEnvironmentalLevelId}
                            onChange={(e: any) => handleValueChanged('siteEnvironmentalLevelId', e.target.value)}
                            disabled={props.readOnly} 
                        >
                            {siteEnvLevelsList.map((mt) => (
                                <MenuItem value={mt.id} key={mt.id}>{mt.name}</MenuItem>
                            ))}
                        </Field>
                        {(selectedSiteEnvLevel?.coatings?.length ?? 0) > 0 && (
                            selectedSiteEnvLevel?.coatings.map((coating) => (
                                <label style={{marginTop: '10px', textAlign: 'left', fontWeight: 'lighter'}} key={coating}>{coating}</label>
                            ))
                        )}
                        <ErrorMessage name="siteEnvironmentalLevelId" component="div" className="text-danger" />
                    </Grid>

                </Grid>
            </FormikProvider>
        </div>
    );
};

export default SiteEnvLevel;
